import type { ArcGisClassBreaksRendererJson } from '../map/buildDefectRulesRenderer';
import { CRACKING_RAG_BANDS } from './crackingBands';

export function buildCrackmapRenderer(
  lineWidth: number = 3,
  lineStyle: string = 'solid',
): ArcGisClassBreaksRendererJson {
  const width = Math.max(1, lineWidth);
  const style = lineStyle.trim() || 'solid';

  return {
    type: 'class-breaks',
    field: 'width',
    defaultSymbol: {
      type: 'simple-line',
      color: CRACKING_RAG_BANDS[0].color,
      width,
      style,
    },
    classBreakInfos: CRACKING_RAG_BANDS.map((band) => ({
      minValue: band.min,
      maxValue: band.max,
      symbol: {
        type: 'simple-line',
        color: band.color,
        width,
        style,
      },
    })),
  };
}
